import {
  Search,
  Briefcase,
} from "lucide-react";

/** Top-level workspace tools. Chat and drafting live inside cases. */
export const WORKSPACE_HOME_TOOLS = [
  {
    section: "research",
    icon: Search,
    titleKey: "nav_research",
    descKey: "home_tool_research_desc",
  },
];

/** Matter-centric workspace — featured separately on the home hub. */
export const WORKSPACE_HOME_CASES = {
  section: "cases",
  icon: Briefcase,
  titleKey: "nav_cases",
  descKey: "home_cases_desc",
  eyebrowKey: "home_cases_eyebrow",
};
